import {DigitalPageItem} from '../../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Sample,
  Title: 'Hello!',
  ProductCode: 'caq72',
  Description:
    'Here\'s all the online content included with your <strong>Chemistry Exam Practice Workbook</strong>.',
  Credits:
    '<i>Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved. <br /> <br /></i>',
  FreeSampleContent:
    '<strong>This is a free sample of the CGP RevisionHub for the A-Level Chemistry Exam Practice Workbook. <u><a href="[[external_domain]]/secondary-books/as-and-a-level" style="color: #FF9335;">Order</a></u> your book now for full access to online Chemistry revision.</strong>',};